export default "__VITE_ASSET__BETEgU65__"